import moment from 'moment'
import {
  fetchOrderAssignments,
  acceptOrderAssignment,
  rejectOrderAssignment
} from '@/services/order-assignments'
import { transformKeysToSnakeCase } from '@/services/utils/casing'
import {
  OrderAssignmentFiltersRequest,
  OrderAssignmentState
} from '@/services/models/order-assignments-model'

function getActivePagination(assignmentState) {
  const { itemsPerPage, pageNumber } = assignmentState.pagination
  return {
    size: itemsPerPage,
    page: pageNumber
  }
}

export const loadAssignments = async (
  { commit },
  query: Partial<OrderAssignmentFiltersRequest> = {}
) => {
  const { progress, ...rest } = query
  const snakeCasedParams: Partial<OrderAssignmentFiltersRequest> = transformKeysToSnakeCase(
    rest
  )
  const data = await fetchOrderAssignments({ state: progress, ...snakeCasedParams })

  commit('setAssignments', {
    ...data,
    lastRefreshed: moment.utc().format(),
    status: progress || OrderAssignmentState.All
  })
  commit('setAssignmentUpdatesCount', 0)
  if (progress === OrderAssignmentState.Pending) {
    commit('setOpenAssignmentsCount', data.pagination.totalCount)
  }
}

export const loadAssignmentUpdates = async ({ commit, state }) => {
  const { orderAssignments } = await fetchOrderAssignments({
    state: state.status,
    after: state.lastRefreshed
  })

  commit('setAssignmentUpdatesCount', orderAssignments.length)
}

export const acceptAssignment = async (store, assignmentId: number) => {
  await acceptOrderAssignment(assignmentId)
  await loadAssignments(store, getActivePagination(store.state))
}

export const rejectAssignment = async (store, assignmentId: number) => {
  await rejectOrderAssignment(assignmentId)
  await loadAssignments(store, getActivePagination(store.state))
}
